/**
 * This is just an example file and can be removed once real reducers are in place
 */
import { IBooking, ILayout, ILayoutMinimalAbstract, IPosition, ITableItem } from 'shared-types/SharedTypes';
import { IDiarySchedule } from 'shared-types/DiaryTypes';
import { ISectionOptions } from 'external-services/section-groups-service/type';

export interface IDragTableBookingSlot {
  tableId: string;
  slotIndex: number;
  startTime: Date;
  bookingIds: string[];
}

export interface ITableDragState {
  dragFromTableId: string;
  dragToTableId: string; // used for dragging over a table
  dragCompleteTableId: string; // used for dragging & dropping onto a table
  dragFromTableBookingSlot: IDragTableBookingSlot;
  dragToTableBookingSlot: IDragTableBookingSlot;
  draggedBookingPoint: IPosition;
  draggedBooking: IBooking;
  bookingToSwap: IBooking;
  bookingConfirmDialogWL?: {
    draggedBooking?: IBooking;
    dragToTableId?: string;
    isOverlap?: boolean;
  };
  dragBookingInfoForModal?: IDragBookingInfoForModal;
  draggedBookingSource: DraggedBookingSourceEnum;
  isLongTouch: boolean;
  isDragActionComplete: boolean;
  isDragSaveActionComplete: boolean;
}
export enum DraggedBookingSourceEnum {
  Table = 'Table',
  BookingCardList = 'BookingCardList',
}

export interface IDragBookingInfoForModal {
  toTable: ITableItem; // can be table or table id
  toTablesArray: ITableItem[]; // can be table or table id
  fromTable: ITableItem; // can be table or table id
  fromTableArray: ITableItem[]; // can be table or table id
  newTime: Date; // guess
  schedule: IDiarySchedule;// guess
  draggedBooking: IBooking; // guess
  swappedWithBooking: IBooking; // guess
  isError: boolean;
  isOverlap: boolean;
  layouts: ILayoutMinimalAbstract[];// guess
  tableJoinSwapError: boolean;
  hasSwappedTableChanged: boolean;
}
